const server_url = '/'
export const checkLogin = async (login, pass) => {
    try {
        let uri = ""
        
        const response = await fetch(server_url + "services/check/login", {
            method: "POST",
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "login": login,
                "password": pass
            })
        });
        if(response.status === 200) { 
            const ret = await response.json();
            //console.log("service addTask response:", ret);
            return ret
        }
        return {}
  
    }
    catch (e) {
        console.log("service catch:", e);
        return { };
    }
  };

  export const get_caravanserail_user_list = async (user_id) => {
    try{ 
        const response = await fetch(server_url + `caravanserails/mesh3d/parameters/${user_id}`, {
            "method": "post"
        })
        if(response.status === 200) { 
            const ret = await response.json();
            //console.log("service addTask response:", ret);
            return ret
        }
        return {}
    }catch(e){

    }
  }